import { SHARED_REACT_QUERY_CONFIG } from '../../constants/reactQuery.constant';
import { vehiclesAPI } from '../../services/vehicles/vehicles.service';

export const VEHICLES_QUERY = 'vehicles';
export const VEHICLES_QUERY_CONFIG = SHARED_REACT_QUERY_CONFIG;

export const vehiclesQuery = async ({ queryKey }: any) => {
  const [, plateNumber] = queryKey;
  const response = await vehiclesAPI();

  if (!plateNumber) return response.data;

  return response.data.filter((v: any) =>
    v.license_plate?.toLowerCase().includes(plateNumber.toLowerCase())
  );
};
